import { render } from "./ArrowTopLeftIcon.vue?vue&type=template&id=3daa8086"
import script from "./ArrowTopLeftIcon.vue?vue&type=script&lang=js"
export * from "./ArrowTopLeftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__